(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-suspensions.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-suspensions.js');
'use strict';

const {
  ActiveSuspension
} = svs.spelpaus.pages.svsSuspension.components;
const ActiveSuspensions = () => {
  const activeSuspensions = ReactRedux.useSelector(state => state.suspension.activeSuspensions || []);
  const hasSuspension = activeSuspensions && activeSuspensions.length > 0;
  if (!hasSuspension) {
    return null;
  }
  return React.createElement("div", {
    className: "align-left margin-xs-bottom-1"
  }, React.createElement("h2", {
    className: "align-center h2"
  }, "Dina aktiva spelpauser"), activeSuspensions && activeSuspensions.length > 0 && activeSuspensions.map(s => React.createElement(ActiveSuspension, {
    key: s.requested,
    suspension: s
  })));
};
svs.spelpaus.pages.svsSuspension.components.ActiveSuspensions = ActiveSuspensions;

 })(window);